<!-- <a class="file-download-link" href="javascript:void(0)" (click)="download()">
  <img *ngIf="!inProgress" src="assets/icons/icon_download.png">
  <mat-spinner *ngIf="inProgress"  [diameter]="25"></mat-spinner>
</a> -->
<a
  class="file-download-link"
  href="javascript:void(0)"
  [attr.aria-label]="'Download ' + fileName"
  (click)="download()">

  <img
    *ngIf="!inProgress"
    src="assets/icons/icon_download.png"
    alt=""
    aria-hidden="true">

  <mat-spinner
    *ngIf="inProgress"
    [diameter]="25"
    aria-hidden="true">
  </mat-spinner>

</a>